import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Grid, FormControl, InputLabel, Select, MenuItem, IconButton, Box, Typography } from '@mui/material';
interface EditUserModalProps {
  open: boolean;
  onClose: () => void;
  user: any;
  onSubmit: (userData: any) => void;
}
const EditUserModal: React.FC<EditUserModalProps> = ({
  open,
  onClose,
  user,
  onSubmit
}) => {
  const [formData, setFormData] = useState({
    email: '',
    fullName: '',
    mobileNumber: '',
    role: '',
    designation: '',
    branchCode: '',
    settlementAccount: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  useEffect(() => {
    if (user) {
      setFormData({
        email: user.email || '',
        fullName: user.fullName || '',
        mobileNumber: user.mobileNumber || '',
        role: user.role || '',
        designation: user.designation || '',
        branchCode: user.branchCode || '',
        settlementAccount: user.settlementAccount || ''
      });
    }
  }, [user]);
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = 'Valid email is required';
    }
    if (!formData.fullName) {
      newErrors.fullName = 'Full name is required';
    }
    if (!formData.mobileNumber || !/^\+92\d{10}$/.test(formData.mobileNumber)) {
      newErrors.mobileNumber = 'Mobile number must be +92 followed by 10 digits';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = () => {
    if (!validateForm()) return;
    onSubmit(formData);
  };
  return <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth data-id="element-2809">
      <DialogTitle data-id="element-2810">
        <Box sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }} data-id="element-2811">
          <Typography variant="h6" data-id="element-2812">Edit User</Typography>
          <IconButton onClick={onClose} data-id="element-2813">
            <div size={20} data-id="element-2814" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent data-id="element-2815">
        <Grid container spacing={2} sx={{
        mt: 1
      }} data-id="element-2816">
          <Grid item xs={12} md={6} data-id="element-2817">
            <TextField fullWidth disabled label="Username" value={user?.username || ''} helperText="Username cannot be changed" data-id="element-2818" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2819">
            <TextField fullWidth required label="Full Name" value={formData.fullName} onChange={e => setFormData({
            ...formData,
            fullName: e.target.value
          })} error={!!errors.fullName} helperText={errors.fullName} data-id="element-2820" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2821">
            <TextField fullWidth required label="Email" type="email" value={formData.email} onChange={e => setFormData({
            ...formData,
            email: e.target.value
          })} error={!!errors.email} helperText={errors.email} data-id="element-2822" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2823">
            <TextField fullWidth required label="Mobile Number" value={formData.mobileNumber} onChange={e => {
            const value = e.target.value;
            if (value.startsWith('+92')) {
              setFormData({
                ...formData,
                mobileNumber: value.slice(0, 13)
              });
            }
          }} error={!!errors.mobileNumber} helperText={errors.mobileNumber || '+92 followed by 10 digits'} data-id="element-2824" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2825">
            <FormControl fullWidth required data-id="element-2826">
              <InputLabel data-id="element-2827">Role</InputLabel>
              <Select value={formData.role} label="Role" onChange={e => setFormData({
              ...formData,
              role: e.target.value
            })} data-id="element-2828">
                <MenuItem value="maker" data-id="element-2829">Maker</MenuItem>
                <MenuItem value="checker" data-id="element-2830">Checker</MenuItem>
                <MenuItem value="admin" data-id="element-2831">Admin</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2832">
            <TextField fullWidth label="Designation" value={formData.designation} onChange={e => setFormData({
            ...formData,
            designation: e.target.value
          })} data-id="element-2833" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2834">
            <TextField fullWidth label="Branch Code" value={formData.branchCode} onChange={e => setFormData({
            ...formData,
            branchCode: e.target.value
          })} helperText="Can be updated via Bank API" data-id="element-2835" />
          </Grid>
          <Grid item xs={12} md={6} data-id="element-2836">
            <TextField fullWidth label="Settlement Account" value={formData.settlementAccount} onChange={e => setFormData({
            ...formData,
            settlementAccount: e.target.value
          })} helperText="Can be updated via Bank API" data-id="element-2837" />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions data-id="element-2838">
        <Button onClick={onClose} data-id="element-2839">Cancel</Button>
        <Button variant="contained" onClick={handleSubmit} data-id="element-2840">
          Save Changes
        </Button>
      </DialogActions>
    </Dialog>;
};
export default EditUserModal;